import { ApolloError, useQuery } from '@apollo/client'
import { MeetingsByReplyerQuery, MeetingsByReplyerQueryVariables } from '../../../types'
import { MEETINGS_BY_REPLYER } from '../meeting.graphql'

export default (
  replyerId: string,
  disputedMeetingsIncluded = false,
): { data: MeetingsByReplyerQuery | undefined; loading: boolean; error: ApolloError | undefined } => {
  const { data, loading, error } = useQuery<MeetingsByReplyerQuery, MeetingsByReplyerQueryVariables>(MEETINGS_BY_REPLYER, {
    variables: {
      replyerId: replyerId,
      disputedMeetingsIncluded,
    },
    fetchPolicy: 'network-only',
  })

  return { data, loading, error }
}
